import PropTypes from 'prop-types';
import React from "react";
import { ItemClientStatuses } from '../../../library/constants/client-statuses.js';
import { ArtworkInReview, Delivered, FinalApproval, InProduction, InTransit, UploadArtwork } from '../index';
import Cancelled from './cancelled';



const StepBody = ({ data, quotationToken, style }) => {
    switch (data.client_status) {
        case ItemClientStatuses.ORDER_CONFIRMATION: return <UploadArtwork item={data} quotationToken={quotationToken} style={style} />
        case ItemClientStatuses.UPLOAD_ARTWORK: return <ArtworkInReview item={data} quotationToken={quotationToken} style={style} />
        case ItemClientStatuses.FINAL_APPROVAL: return <FinalApproval item={data} quotationToken={quotationToken} style={style} />
        case ItemClientStatuses.IN_PRODUCTION: return <InProduction item={data} style={style} />
        case ItemClientStatuses.IN_TRANSIT: return <InTransit item={data} quotationToken={quotationToken} style={style} />
        case ItemClientStatuses.DELIVERED: return <Delivered data={data} quotationToken={quotationToken} style={style} />
        case ItemClientStatuses.CANCELLED: return <Cancelled style={style} />
        default: return <div></div>
    }
}

StepBody.propTypes = {
    data: PropTypes.object,
    quotationToken: PropTypes.string,
    style: PropTypes.object,
}
export default StepBody